import React from 'react'
import Dropzone from 'react-dropzone';
import './renderFileField.css';
import CloudUpload from '@material-ui/icons/CloudUpload';

const RenderFileInput = (field) => {
  const files = field.input.value;
  return (
    <div>
      <Dropzone
        multiple={false}
        activeClassName={'file-upload-area__active'}
        className={'file-upload-area'}
        name={field.name}
        onDrop={( filesToUpload, e ) => field.input.onChange(filesToUpload)}
      >
        <div>Select file to upload.</div>
        <CloudUpload/>
      </Dropzone>
      {field.meta.touched &&
      field.meta.error &&
      <span className="error">{field.meta.error}</span>}
      {files && Array.isArray(files) && (
        <ul>
          { files.map((file, i) => <li key={i}>{file.name}</li>) }
        </ul>
      )}
    </div>
  );
}

export default RenderFileInput



// WEBPACK FOOTER //
// ./src/components/inputs/renderFileField.js